import { gql } from "@apollo/client";
import { businessUnitFragment } from "api/BusinessUnits/queries";

export const organisationFragment = gql`
  fragment Organisation on Organisation {
    id
    name
  }
`;

export const GET_ORGANISATIONS_LIST = gql`
  query GetOrganizations {
    organisations {
      organisation {
        ...Organisation
      }
      businessUnits {
        ...BUFragment
      }
    }
  }
  ${businessUnitFragment}
  ${organisationFragment}
`;

export const GET_ORGANISATIONS_BUSINESS_UNITS = gql`
  query GetOrganisationBusinessUnits($businessUnitId: Int!) {
    organisationBusinessUnits(businessUnit: $businessUnitId) {
      organisation {
        ...Organisation
      }
      ...BUFragment
    }
  }
  ${businessUnitFragment}
  ${organisationFragment}
`;
